import { Paginated } from "./utils";

export enum AssignmentPeriodCloseReason {
  DUPLICATE = "DUPLICATE",
  UNASSIGNMENT = "UNASSIGNMENT",
  CANCELLATION = "CANCELLATION",
  CAPACITY_CHANGE = "CAPACITY_CHANGE",
}

// customer overview
export interface ProvisionStepsListResponseDto {
  steps: ProvisionStepResponseDto[];
}

export interface ProvisionStepResponseDto {
  months: number;
  amount: number;
  furtherRecurring: boolean;
}

export interface ProvisionListResponseDto {
  _id: string;
  name: string;
  belongsToStatus: string;
  profilePictureUrl?: string;
  rating?: number;
  startDate: string;
  provisionAmount: number;
  months: number;
  paidProvisions: PaidProvisionMonthResponseDto[];
  loopState: boolean;
  statusIcon: string;
  statusColor: string;
  statusValue: string;
  statusDate?: string;
}

export interface PaidProvisionMonthResponseDto {
  amount: number;
  months: number;
  provisionDate: string;
  note?: string;
}

// leaderboard

export interface LeaderboardListEmployeeResponseDto {
  place: number;
  name: string;
  amountYear: number;
  amountAllTime: number;
  ownUser: boolean;
}

export interface LeaderboardListResponseDto {
  place: number;
  name: string;
  amountYear: number;
  amountAllTime: number;
  ownUser?: boolean | null;
}

// full bonus

// amount graph

export interface GraphCardContentResponseDto {
  displayNumber: number;
  differenceLastMonth: number;
}

// employee

export interface GraphCardGraphResponseDtoWithTimePeriod {
  monthlyData: MonthlyDataFixMonthDto[];
  timePeriod: TimePeriod;
}

export enum TimePeriod {
  LAST_3_MONTHS = "LAST_3_MONTHS",
  LAST_12_MONTHS = "LAST_12_MONTHS",
  ALL_TIME = "ALL_TIME",
}

export interface MonthlyDataFixMonthDto {
  graphNumber: number;
  month: number;
  year: number;
}

// admin

export interface GraphCardGraphResponseDto {
  monthlyData: MonthlyDataDto[];
  startDate: string;
  endDate: string;
}

export interface MonthlyDataDto {
  graphNumber: number;
  startDate: string;
  endDate: string;
}

// notifications

export interface ProvisionNotificationResponseDto {
  newProvisions: boolean;
  provisionNotificationData?: ProvisionNotificationDataResponseDto[];
}

export interface ProvisionNotificationDataResponseDto {
  provisionAmount: number;
  provisionDate: string;
  provisionIds: string[];
  bonusAnimationUrl: string;
}

// bonus payments
export interface UserProvisionListPaginatedResponseDtoWithSelectedDateRange {
  users: Paginated<UserProvisionListResponseDto>;
  startDate: string;
  endDate: string;
}

export interface UserProvisionListResponseDto {
  _id: string;
  firstName: string;
  lastName: string;
  profilePictureUrl: string;
  paidOutProvision: number;
  sumProvisionAllTime: number;
  sumProvisionSelectedPeriod: number;
  isArchive: boolean;
}

// pay out - {userId}
export interface UserPaidOutProvisionListResponseDto {
  amount: number;
  paidOutProvisionList: PaidProvisionListResponseDto[];
  user: UserPaidProvisionUserResponseDto;
}

export interface PaidProvisionListResponseDto {
  amount: number;
  createdAt: string;
}

export interface UserPaidProvisionUserResponseDto {
  _id: string;
  firstName: string;
  lastName: string;
  profilePictureUrl: string;
}

// pay out provision - {userId}
export interface PayOutProvisionRequestDto {
  belongsToInternalUserId: string;
  amount: number;
}

// get user provision organizations - {userId}
export interface UserProvisionOrganizationsResponseDto {
  userProvisionOrganizations: UserProvisionOrganizationsListResponseDto[];
}

export interface UserProvisionOrganizationsListResponseDto {
  belongsToOrganizationId: string;
  belongsToOrganizationName: string;
  sumProvisionAllTime: number;
  sumProvisionSelectedPeriod: number;
}

// organization history - {organizationId}
export interface UserProvisionHistoryListResponseDto {
  belongsToOrganizationId: string;
  belongsToOrganizationName: string;
  assignmentPeriodChains: AssignmentPeriodChainListResponseDto[];
  totalProvisionAmount: number;
  user: UserPaidProvisionUserResponseDto;
}

export interface AssignmentPeriodChainListResponseDto {
  assignmentPeriodChain: AssignmentPeriodListResponseDto[];
  provisions: PaidProvisionMonthResponseDto[];
  assignmentPeriodData?: AssignmentPeriodDataResponseDto;
}

export interface AssignmentPeriodListResponseDto {
  assignedTimestamp: string;
  unassignedTimestamp?: string;
  isInactive?: boolean;
  earliestNextProvisionDate?: string;
  lastHighestProvisionCalculated?: number;
  note?: string;
  createdAt: string;
  closeReason?: AssignmentPeriodCloseReason;
  organizationCapacity: number;
}

export interface AssignmentPeriodDataResponseDto {
  isActive: boolean;
  startDate: string;
  months: number;
}
